import React from 'react';
import { BlockTypes } from '../../types';
import {
    DashboardSettings,
    SumFieldsSettings,
    DateStatisticsSettings,
    DefaultSettings,
    BlockContainerSettings,
    ListOptionPercentageConditionsSettings,
    CountLinkOptionsSettings,
    OnlyUsersSettings,
    KedoChartsSettings,
    CountListOptionsSettings,
    BlockSettingsProps
} from '../Settings';

const settingsRegistry: Record<string, React.ComponentType<BlockSettingsProps>> = {
    [BlockTypes.Dashboard]: DashboardSettings,
    [BlockTypes.SumField]: SumFieldsSettings,
    [BlockTypes.DateStatistics]: DateStatisticsSettings,
    [BlockTypes.BlockContainer]: BlockContainerSettings,
    [BlockTypes.ListOptionPercentageConditions]: ListOptionPercentageConditionsSettings,
    [BlockTypes.CountLinkOptions]: CountLinkOptionsSettings,
    [BlockTypes.CountListOptions]: CountListOptionsSettings,
    [BlockTypes.OnlineUsers]: OnlyUsersSettings,
    [BlockTypes.KedoCharts]: KedoChartsSettings,

};

export const getBlockSettingsComponent = (blockType: string): React.ComponentType<BlockSettingsProps> => {
    return settingsRegistry[blockType] || DefaultSettings;
};